import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { PiArrowCircleRightThin } from "react-icons/pi";
import { PiArrowCircleRightFill } from "react-icons/pi";
import colors from "../../styles/colors";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

const ContactUsSection = () => {
  const { t } = useTranslation(); // Hook a fordításhoz
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section
    className="relative w-full min-h-[30vh] max-h-[70vh] flex flex-col items-center justify-center text-center py-24 px-8"
    style={{ backgroundImage: "url('/assets/images/home/ContactSection/darkwood_bg.webp')", backgroundSize: "cover", backgroundPosition: "center" }}
  >
      {/* Fő szöveg */}
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ duration: 0.8 }}
        className="lg:text-6xl text-4xl md:text-5xl font-serif p-4 mt-12"
        style={{color: colors.lightCream}}
      >
        {t('contactUsSection.mainText')} 
        <span style={{ color: colors.pastelGreen, fontStyle: "italic"}}>{t('contactUsSection.project')}</span>?
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="lg:text-4xl text-2xl md:text-4xl p-2 mt-6 font-serif"
        style={{color: colors.lightCream}}
      >
        <span style={{ color: colors.pastelGreen, fontStyle: "italic" }}>{t('contactUsSection.getInTouch')}</span> 
        {t('contactUsSection.moreInfo')}
      </motion.p>

      {/* Csak az ikon (hoverkor váltás) */}
      <motion.button
        onClick={() => navigate("/contact")}
        className="mt-12 rounded-full flex items-center justify-center"
        initial={{ scale: 1 }}
        whileHover={{ scale: 1.2 }}
        whileTap={{ scale: 0.95 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <AnimatePresence mode="wait">
          {isHovered ? (
            <motion.span
              key="filled-icon"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.2 }}
            >
              <PiArrowCircleRightFill size={75} color={colors.lightCream} />
            </motion.span>
          ) : (
            <motion.span
              key="thin-icon"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.2 }}
            >
              <PiArrowCircleRightThin size={75} color={colors.lightCream} />
            </motion.span>
          )}
        </AnimatePresence>
      </motion.button>
    </section>
  );
};

export default ContactUsSection;
